import React, { useCallback } from 'react';
import { CategorySelect } from './CategorySelect';
import { SubCategorySelect } from './SubCategorySelect';
import { FormValue } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/types';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';
import { useAppSelector } from 'src/utils/Hooks';

export const CategoryAndSubcategorySelect = () => {
  const {
    selections: { watch, setValue }
  } = usePresentationFormContext();

  const [selectionOrder, setSelectionOrder] = React.useState<'category' | 'subcategory' | null>(null);

  const categoryIds = watch('categoryIds');
  const subcategoryIds = watch('subcategoryIds');
  const subCategories = useAppSelector((state) => state.subCategories);

  const handleCategoryChange = useCallback((newValue: any[]) => {
    if (newValue.length > 0 && !selectionOrder) {
      setSelectionOrder('category');
    }

    if (selectionOrder === 'category') {
      if (newValue.length > 0) {
        const validSubcategoryIds = subcategoryIds.filter(subcat => {
          const subcategory = subCategories.find(sc => sc.id.toString() === subcat.id);
          return subcategory && newValue.some(cat => cat.id === subcategory.parentCategoryId.toString());
        });

        if (validSubcategoryIds.length !== subcategoryIds.length) {
          setValue('subcategoryIds', validSubcategoryIds);
        }
      } else {
        setSelectionOrder(null);
        setValue('subcategoryIds', []);
      }
    }
  }, [subcategoryIds, subCategories, selectionOrder, setValue]);

  const handleSubcategoryChange = useCallback((newValue: FormValue[]) => {
    if (newValue.length > 0 && !selectionOrder) {
      setSelectionOrder('subcategory');
    }

    if (selectionOrder === 'subcategory') {
      if (newValue.length > 0) {
        const selectedSubcats = subCategories.filter(subcat =>
          newValue.some(selected => selected.id === subcat.id.toString())
        );

        const validCategoryIds = categoryIds.filter(cat =>
          selectedSubcats.some(subcat => subcat.parentCategoryId.toString() === cat.id)
        );

        if (validCategoryIds.length !== categoryIds.length) {
          setValue('categoryIds', validCategoryIds);
        }
      } else {
        setSelectionOrder(null);
        setValue('categoryIds', []);
      }
    }
  }, [categoryIds, subCategories, selectionOrder, setValue]);

  return (
    <>
      <CategorySelect
        selectionOrder={selectionOrder}
        onSelectionChange={handleCategoryChange}
        selectedSubcategoryIds={subcategoryIds}
      />
      <SubCategorySelect
        selectedCategoryIds={categoryIds}
        selectionOrder={selectionOrder}
        onSelectionChange={handleSubcategoryChange}
      />
    </>
  );
};
